import { render, staticRenderFns } from "./TreasurehuntObjectForm.vue?vue&type=template&id=bf7da2e0&scoped=true&"
import script from "./TreasurehuntObjectForm.vue?vue&type=script&lang=js&"
export * from "./TreasurehuntObjectForm.vue?vue&type=script&lang=js&"
import style0 from "./TreasurehuntObjectForm.vue?vue&type=style&index=0&id=bf7da2e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7da2e0",
  null
  
)

export default component.exports